import React from "react";
import "./BottomSheet.scss";
import Icon from "../../lib/icon";

export default function BottomSheet({
  open,
  onClose,
  children,
  zIndex = 100,
  closeButtomShow = false,
  header = undefined,
  className = "",
}) {
  if (!open) return null;

  return (
    <div
      className={`bottom-sheet ${className}`}
      style={{ zIndex }}
      onClick={onClose}
    >
      <div className="bottom-sheet__overlay" onClick={onClose}>
        <div
          className="bottom-sheet__panel"
          onClick={(e) => e.stopPropagation()}
        >
          {header != undefined ? (
            <div className="title-bottom"><span>{header}</span></div>
            ):(<></>)}
          {closeButtomShow ? (
            <button className="btn btn-bottom-close" onClick={onClose}>
              <Icon 
                name="dismiss"
                width={18}
                height={18}
              ></Icon>
            </button>
            ):(<></>)}
          {children}
        </div>
      </div>
    </div>
  );
}
